import Model        from "./Model";

export default class Logo extends Model
{
    constructor( options = {} )
    {
        super('/api/v1/rqs');

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id         = options.id        || null;
        this.title      = options.title     || null;
        this.name       = options.name      || null;
        this.url        = options.url       || null;
        this.mime       = options.mime      || null;
        this.size       = options.size      || null;
        this.width      = options.width     || null;
        this.height     = options.height    || null;
    }

    toJson()
    {
        return {
            'id'        : this.id,
            'title'     : this.title,
            'name'      : this.name,
            'url'       : this.url,
            'mime'      : this.mime,
            'size'      : this.size,
            'width'     : this.width,
            'height'    : this.height,
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/models/Logo.js